/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Previous_Sessions_TitleInputs */

const fr_previous_sessions_title = /** @type {(inputs: Previous_Sessions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions précédentes`)
};

/**

* @param {Previous_Sessions_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const previous_sessions_title = /** @type {((inputs?: Previous_Sessions_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previous_Sessions_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_previous_sessions_title(inputs)
});